import { SET_GOLOBAL_LANGUAGE } from "../actions/type.action";

const initialAuth = {
  language: 'en-us', // 'en-us'
};

export const i18nReducer = (state = initialAuth, action) => {
  switch (action.type) {
  case SET_GOLOBAL_LANGUAGE:
    return {
      ...state,
      language: action.payload,
    };
  default:
    return state;
  }
};
